import $ from 'jquery'
import recentSearch from './storage'

const SHOW_ITEMS_NUM = 5;


/**
 * 请求参数转obj
 * @param {string} queryStr 
 */
function parseQuery(queryStr) {

    let ret = {};
    queryStr.split('&').forEach(function (pair) {
        let splited = pair.split('=');
        ret[splited[0]] = splited[1];
    });
    return ret;

}

/**
 * url 参数替换
 * @param {*} template 
 * @param {*} data 
 */
function replaceIndex(template, data) {
    return template.replace(/\{(\d+)\}/g, function (a, index) {
        return data[index] || '';
    });

}

/**
 * 节流函数
 * @param {*} fn 
 * @param {*} time 
 */
function lastRun(fn, time) {
    let handler = null;
    time = time || 100;
    return function () {
        if (handler) {
            clearTimeout(handler);
        }
        let self = this,
            argus = arguments;
        handler = setTimeout(function () {
            fn.apply(self, argus);
            handler = null;

        }, time);

    };

}

function init(config) {

    let channelId = [0, 0],
        container = config.container,
        searchInput = container.find('.J-search-input'),
        searchBtn = container.find('.J-search-btn'),
        cityId = config.cityId || searchInput.attr('data-s-cityid'),
        category = config.channelId || searchInput.attr('data-s-cateid'),
        searchPattern = searchInput.attr('data-s-pattern'),
        searchEmptyPattern = searchInput.attr('data-s-epattern'),
        autoCompletePattern = '/ajax/json/suggest/search?do=hsc&c={0}&s={1}',
        searchBntNums = searchBtn.length;
    
    Array.from(searchBtn).forEach((item, index) => {
        channelId[index] = item.getAttribute('data-s-chanid'); 
    })
    

    let searchPicker = {
        selectedIndex: -1,
        itemActiveClass: 'active',
        itemSelector: 'a.suggest-item',
        panelContainer: container,
        panel: $('<div class="dp-search-suggest Hide">'), // 下拉框容器
        listRender: function (item) {
            let renderTpl = {
                // 固定栏标题
                'title': function (item) {
                    return `<span class="suggest-item ac-type-title"><span class="keyword">${item.text}</span></span>`;
                },

                // 搜索记录
                'log': function (item) {
                    return `<a class="suggest-item ac-type-log"><span class="keyword">${item.text}</span><span class="remove">删除</span></a>`;
                },
                // 搜索结果条目
                'search': function (it) {
                    let item = it.content;
                    let splited = item.split('|'),
                        text = splited[0], // 结果名称
                        count = splited[2], // 结果个数
                        inputText = new RegExp('^(' + searchInput.val().trim() + ')', 'i');

                    // 匹配高亮显示
                    return '<a class="suggest-item"><span class="keyword">' + text.replace(inputText, '<em>$1</em>') + '</span>' +
                        '<span class="count">' + count + '</span></a>';

                }
            }
            return $(renderTpl[item.renderType](item))

        },
        render: function (keyword, arr) { // 渲染搜索框 arr为[]数据，keyword为绑定的关键字
            let panel = this.panel;
            let listRender = this.listRender;

            if (arr.length) {
                panel.empty();

                // create empty item set
                let items = $();
                arr.forEach(function (data, i) {

                    data.index = i;
                    data.keyword = keyword;

                    let item = listRender(data);
                    item.appendTo(panel).data({
                        index: i,
                        keyword: keyword,
                        data: data
                    });
                    items = items.add(item);

                }, this);

                if (container) {
                    panel.appendTo(container);
                }

                this.items = items;
                items = null;

            }

            // reset index
            this.selectedIndex = -1;

        },
        show: function () { // 展开

            let pos = searchInput.offset();

            this.panel.css({
                left: pos.left,
                top: pos.top + searchInput.outerHeight()
            });
            this.panel.removeClass('Hide');

        },
        hide: function () {
            this.panel.addClass('Hide');
        }
    }

    /**
     * input框的基本搜索功能
     */
    const baseSearch = (function () {

        // 过滤输入的内容
        let VALUE_SANTITIZER = /[\\<]+/g, // 转义\ < 
            patternData = Array.prototype.slice.call(arguments);

        /**
         * click 回掉函数
         */
        function clickCB(e) {

            // 组装url,注意区分本站搜和全站搜
            let channelIdTarget = $(e.target).attr('data-s-chanid') || '0';
            if(searchBntNums === 2){ // 有两种搜索 替换全站搜channelId
                    patternData[1] = channelIdTarget;
                }
            let value = searchInput.val().replace(VALUE_SANTITIZER, '').trim().replace(/\//g, ''),
                searchPath = formatData(searchPattern),
                searchEmptyPath = formatData(searchEmptyPattern, {onChangeChannleId: true}),
                
                redirectPath = searchPath.indexOf('{q}') !== -1
                    ? searchPath.replace('{q}', encodeURIComponent(value))
                    : (searchPath + encodeURIComponent(value));
            if (value || searchEmptyPath) {
                if (value.length > 0) {
                    recentSearch.add(value);
                }
                window.open(value.length > 0 ? redirectPath : searchEmptyPath, '_blank');
            } else {
                searchInput.focus();
            }
            return false;
        }

        /**
         * url 规则替换
         * @param {*} pattern 
         */
        function formatData(pattern, options) {
            let data = patternData, // {cityId, cateId}
                offset = data.length;
            if (options && options.onChangeChannleId) {
                pattern = pattern.replace('{0}', 'ch'+data[1]);
            } else { 
                while (offset--) {
                    pattern = pattern.replace('{' + offset + '}', data[offset]);
                }
            }
            
            return pattern;
        }

        function selectedCB(keyDerection = 'down') {
            let activeNode,
                searchPanel = searchPicker.panel.children(),
                nodeLen = searchPanel.length;
            if (keyDerection === 'up') {
                searchPicker.selectedIndex = (searchPicker.selectedIndex + nodeLen) % nodeLen;
                activeNode = searchPanel.eq(--searchPicker.selectedIndex);
                if (activeNode.hasClass('ac-type-title') && searchPicker.selectedIndex == 0) {
                    activeNode = searchPanel.eq(--searchPicker.selectedIndex);
                }
            }
            if (keyDerection === 'down') {
                searchPicker.selectedIndex = (++searchPicker.selectedIndex + nodeLen) % nodeLen;
                activeNode = searchPanel.eq(searchPicker.selectedIndex);
                if (activeNode.hasClass('ac-type-title') && searchPicker.selectedIndex == 0) {
                    activeNode = searchPanel.eq(++searchPicker.selectedIndex);
                }
            }
            activeNode.addClass('active').siblings().removeClass('active')
            searchInput.val(activeNode.find('.keyword').text());
            // console.log(searchPicker.selectedIndex)
        }
        

        searchInput.on('keydown', function (e) { // enter
            if (searchPicker.isCommand(e)) {

                if (e.keyCode === 38) {
                    selectedCB('up')
                }
                if (e.keyCode === 40) {
                    selectedCB('down')
                }
                if (e.keyCode === 13) {
                    searchPicker.selectedIndex = -1;

                    $(searchBtn[0]).trigger('click');
                    return false;
                } else {
                    return false;
                }
            }
        })

        Array.from(searchBtn).forEach((item) => {
            $(item).on('click', clickCB);
        })
        

        return {
            s: VALUE_SANTITIZER,
            // set the new data of cityID and categoryID
            data: function () {
                patternData = arguments;
            },
            submit: clickCB
        }

    })(cityId, channelId[0]);

    /**
     * 带下扩展功能的input框
     */
    if (baseSearch && container.length) {

        baseSearch.submit = (function (submitCB) { // 确认提交搜索结果

            return function (e) {
                submitCB(e);
            };

        })(baseSearch.submit);


        // 搜索下拉框功能扩展
        let searchOptions = {
            clear: function () { // 清空匹配框和数据，并发送render事件
                this.panel.empty();
                this.items = $();
                this.selectedIndex = -1;
            },

            renderDefault: function () { // 没有输入时默认显示的匹配  -- 最近搜索
                let recentItems = recentSearch.get(SHOW_ITEMS_NUM);
                if (recentItems.length) {
                    this.render('', recentItems);
                } else {
                    this.clear();
                }
            },

            isCommand: function (e) { // 是否为回车、向上和向下键
                return e && /^(13|38|40)$/.test(e.keyCode);

            },

            /**
             * 请求数据并渲染,默认搜索框的数据是从全站出来的
             */
            fetch: lastRun(function (e) {
                let value = searchInput.val().trim(),
                    query = {},
                    url = replaceIndex(autoCompletePattern, [cityId, category]);// '/ajax/json/suggest/search?do=hsc&c=cityId&s=category'

                let splited = url.split('?');
                if (splited[1]) { // 带参数的请求
                    query = parseQuery(splited[1]);
                }
                query['q'] = value;

                if (!searchPicker.isCommand(e)) {
                    $.ajax({
                        type: 'GET',
                        url: config.domain + splited[0],
                        data: query,
                        success: function (json) {
                            let arr;
                            if (json.code == 101) {

                                arr = json.msg.shop || [];
                                if (arr.length) {
                                    if (value === '') {
                                        searchPicker.renderDefault();
                                    } else {
                                        let lastArr = [];
                                        arr.forEach(function (data) {
                                            let content = { renderType: 'search', 'content': data };
                                            lastArr.push(content);
                                        });
                                        searchPicker.render(value, lastArr);
                                    }
                                } else if (value) {
                                    searchPicker.clear();
                                }
                            } else {
                                searchPicker.clear();
                            }
                        },
                        error: function (e) {
                            searchPicker.clear();
                            console.log(`搜索结果有误: ${e}`);
                        }
                    })
                }
            }),
        }

        $.extend(searchPicker, searchOptions);

        // 删除最近搜索功能
        searchPicker.panel.on('click', '.remove', function (e) {
            let text = $(this).parent('.suggest-item').data('data').text;
            recentSearch.remove(text);
            searchPicker.renderDefault();
            e.stopPropagation();
        }).on('click', '.suggest-item', function (e) { // 获取选中项
            let text = '',
                type = $(this).data('data').renderType;
            if (type === 'log' || type === 'search') {
                if (type === 'log') {
                    text = $(this).data('data').text;
                }
                if (type === 'search') {
                    text = $(this).data('data').content.split('|')[0];
                }
                searchInput.val(text);
                baseSearch.submit(e);
                searchPicker.hide();
            }
            e.stopPropagation();
        });


        // 处理搜索框事件
        searchInput
            .on('focus', function () {
                searchPicker.show();
            })
            // .on('blur', function () {
            //     // console.log('blur')
            //     searchPicker.hide();
            // })
            .on('keyup', searchPicker.fetch)
            .on('click', function (e) {
                e.stopPropagation(); // 阻止冒泡
            })

        $(document).on('click', function () {
            searchPicker.hide();
        })
        searchPicker.renderDefault();
    }

}


export default {
    init: function (config) {
        init(config);

    }
}





// WEBPACK FOOTER //
// ./modules/logo-input/js/input-search.js